import { useEffect, useState } from "react";
import { Pencil, Plus, Trash2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

const EMPTY = { question: "", answer: "" };
const inputCls = "w-full rounded-lg border border-input bg-[#060B18] px-3 py-2 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500";

export default function FaqTab() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/faq").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(`/admin/faq/${editing}`, form);
        toast.success("Question mise à jour");
      } else {
        await api.post("/admin/faq", form);
        toast.success("Question ajoutée");
      }
      setForm(EMPTY);
      setEditing(null);
      load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/admin/faq/${id}`);
      toast.success("Question supprimée");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="grid gap-6" data-testid="faq-admin">
      <form onSubmit={submit} className="card-tactical grid gap-4 p-5" data-testid="admin-faq-form">
        <p className="flex items-center gap-2 font-heading text-lg font-bold uppercase">
          {editing ? <Pencil className="h-5 w-5 text-orange-500" /> : <Plus className="h-5 w-5 text-orange-500" />}
          {editing ? "Modifier la question" : "Ajouter une question FAQ"}
        </p>
        <input placeholder="Question (ex : Quels sont les délais de livraison ?)" value={form.question} data-testid="admin-faq-question"
          onChange={(e) => setForm({ ...form, question: e.target.value })} className={inputCls} required />
        <textarea placeholder="Réponse détaillée" value={form.answer} rows={3} data-testid="admin-faq-answer"
          onChange={(e) => setForm({ ...form, answer: e.target.value })} className={inputCls} required />
        <div className="flex gap-3">
          <button type="submit" data-testid="admin-faq-submit"
            className="rounded-lg bg-orange-500 px-5 py-2.5 text-sm font-bold uppercase text-[#060B18] transition-all hover:scale-[1.02] hover:bg-orange-400">
            {editing ? "Enregistrer" : "Ajouter"}
          </button>
          {editing && (
            <button type="button" onClick={() => { setEditing(null); setForm(EMPTY); }} data-testid="admin-faq-cancel"
              className="rounded-lg border border-slate-600 px-5 py-2.5 text-sm font-bold uppercase text-slate-300">
              Annuler
            </button>
          )}
        </div>
      </form>

      <div className="grid gap-3">
        {items.map((f) => (
          <div key={f.id} data-testid={`admin-faq-row-${f.id}`} className="card-tactical flex flex-wrap items-start justify-between gap-3 p-4">
            <div className="min-w-0 flex-1">
              <p className="font-heading text-lg font-bold uppercase">{f.question}</p>
              <p className="mt-1 line-clamp-2 text-sm text-slate-400">{f.answer}</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => { setEditing(f.id); setForm({ question: f.question, answer: f.answer }); }}
                data-testid={`admin-faq-edit-${f.id}`}
                className="rounded-lg border border-orange-500/40 p-2 text-orange-400 hover:bg-orange-500/10"><Pencil className="h-4 w-4" /></button>
              <button onClick={() => remove(f.id)} data-testid={`admin-faq-delete-${f.id}`}
                className="rounded-lg border border-red-500/40 p-2 text-red-400 hover:bg-red-500/10"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
